export default "__VITE_ASSET__3887c83e__$_?nuxt_component=async__"